import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Instagram, Facebook, Twitter, Mail, Phone } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#111] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src="/logo-neldaari.png" alt="NelDaari" className="w-9 h-9" />
            <span className="font-display text-2xl font-semibold">NelDaari</span>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            {t("footer.tagline")}
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" className="rounded-full bg-white/10 hover:bg-white/20 p-2"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="rounded-full bg-white/10 hover:bg-white/20 p-2"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="rounded-full bg-white/10 hover:bg-white/20 p-2"><Twitter className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">{t("footer.discover")}</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/restaurants">{t("footer.allRestaurants")}</Link></li>
            <li><Link to="/restaurants?category=guineen">{t("footer.guineanCuisine")}</Link></li>
            <li><Link to="/restaurants?category=grillades">{t("footer.grills")}</Link></li>
            <li><Link to="/restaurants?category=fastfood">{t("footer.fastFood")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">{t("footer.partners")}</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/devenir-partenaire">{t("footer.becomePartner")}</Link></li>
            <li><Link to="/devenir-livreur">{t("footer.becomeDriver")}</Link></li>
            <li><Link to="/offrir" data-testid="footer-gift-link" className="text-brand-yellow font-semibold">{t("footer.giftMeal")}</Link></li>
            <li><Link to="/about">{t("footer.about")}</Link></li>
            <li><Link to="/terms">{t("footer.terms")}</Link></li>
            <li><Link to="/confidentialite" data-testid="footer-privacy-link">{t("footer.privacy")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> +33 7 58 26 24 47</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> contact@neldaari.com</li>
            <li>{t("footer.city")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
          <div>{t("footer.rights", { year: new Date().getFullYear() })}</div>
          <div className="flex gap-4">
            <Link to="/terms">{t("footer.terms")}</Link>
            <Link to="/confidentialite">{t("footer.privacy")}</Link>
            <Link to="/contact">{t("footer.help")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
